const scrollToTop = document.querySelector('.scroll-to-top')

const fn = {
  init: () => {
    fn.bindEvents()

    fn.handleScroll()
  },

  bindEvents: () => {
    window.addEventListener('scroll', fn.handleScroll)
  },

  handleScroll: () => {
    const offset =
      (document.documentElement.scrollTop + document.body.scrollTop) /
      (document.documentElement.scrollHeight - document.documentElement.clientHeight)

    if (offset > 0.4) {
      scrollToTop.classList.remove('is-hidden')
    } else {
      scrollToTop.classList.add('is-hidden')
    }
  },
}

export default {
  can: () => scrollToTop,
  run: fn.init,
}
